import React, { useState } from 'react';
import {
  ToggleWrapper,
  PhotoWrapper,
  UpperWrapper,
  ShortInfo,
  PhotoNameWrapper,
  DescHolder,
  LongInfo,
  TitleDesc,
  ContactButton,
  Copied,
  ActionHolder,
  ButtonHolder,
} from './styles';

//Pics
import AHK from 'assets/images/AHK.png';

//Additions
import DarkModeToggle from 'react-dark-mode-toggle'; //https://github.com/cawfree/react-dark-mode-toggle#readme

export const UpperHolder = ({
  onBackClick,
  mode,
  onChange,
  palette,
  textPalette,
}) => {
  const [contact, setContact] = useState('Contact Me');
  const [copied, setCopied] = useState(false);

  const copyEmailAddress = () => {
    const textField = document.createElement('textarea');
    textField.innerText = 'aaronkaneti@gmail.com';
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  return (
    <UpperWrapper>
      <ToggleWrapper>
        <DarkModeToggle onChange={onChange} checked={mode} size={75} />
      </ToggleWrapper>

      <PhotoNameWrapper>
        <PhotoWrapper place="intro" palette={palette}>
          <img alt="my-pic" src={AHK} />
          <ShortInfo two palette={palette}>
            a Fullstack Engineer
          </ShortInfo>
        </PhotoWrapper>
        <DescHolder palette={palette} textPalette={textPalette}>
          <h1>Aaron Kaneti</h1>
          <br />
          <TitleDesc>Software Engineer based out of the SF Bay Area</TitleDesc>
          <LongInfo textPalette={textPalette}>
            A software engineer that strives to create code that is as
            ergonomically induced as possible. My aim, when coding, is to create
            code that anyone can understand.
          </LongInfo>
          <ButtonHolder>
            <ContactButton
              palette={palette}
              onMouseEnter={() => {
                setContact('aaronkaneti@gmail.com');
              }}
              onMouseLeave={() => setContact('Contact Me')}
              onClick={() => copyEmailAddress()}
            >
              {contact}
            </ContactButton>
          </ButtonHolder>
          <Copied palette={palette} copied={copied}>
            Copied to clipboard.
          </Copied>
        </DescHolder>
      </PhotoNameWrapper>
      <ActionHolder>
        <i className="ri-arrow-down-line" onClick={onBackClick} />
        <ContactButton
          palette={palette}
          onMouseEnter={() => {
            setContact('aaronkaneti@gmail.com');
          }}
          onMouseLeave={() => setContact('Contact Me')}
          onClick={() => copyEmailAddress()}
        >
          {contact}
        </ContactButton>
      </ActionHolder>
    </UpperWrapper>
  );
};
